import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { ScreenLoader } from '@/shared/components/common/screen-loader'

import { useAuth } from '../auth-context'

export function ProtectedRoute() {
  const { isInitializing, isAuthenticated } = useAuth()
  const location = useLocation()

  if (isInitializing) {
    return <ScreenLoader />
  }

  if (!isAuthenticated) {
    return <Navigate replace state={{ from: location }} to="/login" />
  }

  return <Outlet />
}
